module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-3-ac206ab2165040d9576d8247bc23047a.jpg";